import { getIdToken } from "../auth/msal";

// Centralizes API wiring so the ~14 api/*.ts modules keep calling fetch("/api/…")
// unchanged. When hosted under the Workbench domain, VITE_API_BASE points at the
// cross-origin vrig API host and the Entra ID token is attached; in dev the base
// is empty and the vite proxy forwards /api locally.
const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? "";
const nativeFetch = window.fetch.bind(window);

window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  if (typeof input === "string" && input.startsWith("/api")) {
    const headers = new Headers(init?.headers);
    if (!import.meta.env.DEV) {
      try {
        headers.set("Authorization", `Bearer ${await getIdToken()}`);
      } catch {
        // Not signed in yet; AuthGate drives the redirect.
      }
    }
    return nativeFetch(API_BASE + input, { ...init, headers });
  }
  return nativeFetch(input, init);
};
